
import { createRoot } from 'react-dom/client';
import App from './App.tsx';
import './index.css';
import './i18n'; // Import i18n configuration before rendering the app
import { disableContextMenu } from './utils/disableContextMenu';
import { installDomTranslationGuard } from './utils/domTranslationGuard';

installDomTranslationGuard();

// Update theme colors for the application
document.documentElement.style.setProperty('--primary', '210 100% 50%'); // Blue color for primary 
document.documentElement.style.setProperty('--primary-foreground', '#ffffff');
document.documentElement.style.setProperty('--accent', '210 100% 50%');
document.documentElement.style.setProperty('--accent-foreground', '#ffffff');

// Disable context menu on links
disableContextMenu();

createRoot(document.getElementById("root")!).render(
  <App />
);
